<template>
  <v-dialog v-model="show" persistent width="700">
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <div>{{ dialogTitle }}</div>
        <div class="text-right">
          <v-btn fab text small right @click="handleClose"
            ><v-icon>close</v-icon></v-btn
          >
        </div>
      </v-card-title>
      <v-card-subtitle>Total: {{ totalClickOrShareCount }} </v-card-subtitle>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="businessCards"
          disable-pagination
          hide-default-footer
          class="mt-0"
        >
          <template slot="header.clickCount">
            {{
              type == constants.MULTI_CONNECT_ANALYTICS.SPONSOR
                ? "Click count"
                : "Share count"
            }}
          </template>
          <template v-slot:item.name="{ item }">
            <v-list-item>
              <UserAvatar
                :key="item.businessCardId"
                :usersInitials="item.firstName[0] + ' ' + item.lastName[0]"
                :displayImageUrl="item.displayImageUrl"
              />

              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  {{ item.firstName + " " + item.lastName }}</v-list-item-title
                >
                <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:item.jobTitle="{ item }">
            {{ item.jobTitle != "" ? item.jobTitle : "-" }}
          </template>
          <template v-slot:item.company="{ item }">
            {{
              item.businessName != "" && item.businessName != undefined
                ? item.businessName
                : "-"
            }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import constants from "@/shared/constants";

import UserAvatar from "@/components/UserAvatar";
import {getBusinessCardsDoc} from "@/shared/firebase_utils";

export default {
  props: {
    show: { type: Boolean, default: false },
    dialogTitle: { type: String, default: "" },
    type: { type: String, default: constants.MULTI_CONNECT_ANALYTICS.SPONSOR },
    analyticData: {
      type: Array,
      default: function () {
        return [];
      },
    },
    totalClickOrShareCount: { type: Number, default: 0 },
  },
  components: {
    UserAvatar,
  },
  created() {
    this.constants = constants;
    this.getBusinessCardData();
  },

  watch: {
    show: function (newValue) {
      if (newValue) {
        this.getBusinessCardData();
      }
    },
  },
  data() {
    return {
      businessCards: [],
      headers: [
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        { text: "Business Name", value: "company", align: "start" },
        { text: "Job Title", value: "jobTitle", align: "start" },
        {
          text: "Click Count",
          value: "clickCount",
          align: "start",
        },
      ],
      constants: {},
    };
  },
  methods: {
    async getBusinessCardData() {
      console.log("called");

      console.log("this.businessCards: ", this.businessCards);

      //Read business cards from firestore
      await Promise.all(
        this.analyticData.map(async (item) => {
          //Get the business card ref
          const businessCardDocRef = await getBusinessCardsDoc(item.businessCardId);

          //Get the business card data if it exists
          if (businessCardDocRef.exists) {
            this.businessCards.push({
              id: businessCardDocRef.id,
              ...businessCardDocRef.data(),
              clickCount: item.clickCount || item.shareCount,
            });
          }
        })
      );

      console.log("businesscards: ", this.businessCards);
    },
    handleClose() {
      this.$emit("close");
      // this.businessCards = [];
      // this.headers = [];
    },
  },
};
</script>

<style>
</style>